import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const XAd = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12691"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12691)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0664"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0176"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6228"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.145"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.145"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.6047"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.6047"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1531"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8909"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6934 75.0875C54.757 74.9995 54.8881 74.9995 54.9517 75.0875L55.3341 74.8113L54.9517 75.0875L61.9879 84.83C62.064 84.9354 61.9887 85.0826 61.8588 85.0826H47.7863C47.6564 85.0826 47.5811 84.9354 47.6572 84.83L54.6934 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M95.5331 30.075C95.5899 30.1279 95.6358 30.1915 95.668 30.2621C95.7002 30.3327 95.7182 30.409 95.721 30.4866C95.7237 30.5642 95.7112 30.6415 95.684 30.7143C95.6568 30.787 95.6156 30.8536 95.5626 30.9104L90.7557 36.0654L96.0613 43.108C96.1273 43.1957 96.1675 43.3001 96.1774 43.4094C96.1874 43.5188 96.1667 43.6287 96.1177 43.7269C96.0687 43.8251 95.9933 43.9078 95.8999 43.9655C95.8066 44.0233 95.699 44.0539 95.5892 44.0539H92.3527C92.2611 44.054 92.1709 44.0327 92.0889 43.9919C92.007 43.9511 91.9357 43.8918 91.8806 43.8188L88.1466 38.8635L83.4826 43.866C83.3758 43.9806 83.2277 44.0481 83.0711 44.0536C82.9145 44.0591 82.7621 44.0021 82.6475 43.8953C82.5329 43.7884 82.4654 43.6404 82.4599 43.4838C82.4544 43.3271 82.5114 43.1748 82.6182 43.0601L87.4252 37.9052L82.1196 30.8626C82.0536 30.7749 82.0134 30.6705 82.0034 30.5613C81.9934 30.452 82.0141 30.3421 82.063 30.2439C82.112 30.1457 82.1873 30.0631 82.2806 30.0053C82.3738 29.9475 82.4813 29.9168 82.5911 29.9167H85.8282C85.9196 29.9167 86.0098 29.938 86.0916 29.9788C86.1734 30.0196 86.2446 30.0788 86.2997 30.1518L90.0337 35.1071L94.6971 30.1045C94.75 30.0477 94.8135 30.0019 94.8842 29.9696C94.9548 29.9374 95.0311 29.9194 95.1087 29.9166C95.1862 29.9139 95.2636 29.9265 95.3363 29.9536C95.4091 29.9808 95.4763 30.022 95.5331 30.075ZM89.5362 36.411C89.5195 36.3917 89.5042 36.3714 89.4901 36.3501L85.5334 31.0977H83.7757L92.6469 42.8728H94.4046L89.5362 36.411Z"
            fill="black"
          />
        </g>
      </SvgIcon>
    );
  })
);
